import React, { Component } from 'react'
import { Menu, Icon, Row, Col, Dropdown } from 'antd'
import { map, find } from 'lodash'
import Gravatar from 'react-gravatar'

import logic from './logic'

@logic
export default class ShopSelector extends Component {
  setActiveShop = ({key, ...other}) => {
    const { shopChoices } = this.props;
    const { selectNewShop } = this.props.actions;
    const choice = find(shopChoices, {value: key});
    selectNewShop(key, choice && choice.object);
  };

  render() {
    const { activeShop, shopChoices, activeUser } = this.props;

    const menuItems = map(shopChoices, (shopChoice) => {
      return <Menu.Item key={shopChoice.value}>{ shopChoice.label }</Menu.Item>
    });

    const menu = (
      <Menu
        theme="dark"
        selectedKeys={activeShop ? [activeShop.url] : undefined}
        onClick={ this.setActiveShop }
      >
        { menuItems }
      </Menu>
    );

    return (
      <div className="shop-selector">
        { activeShop ?
          <Dropdown overlay={menu} trigger={['click']}>
            <Row>
              <Col span={ 6 }>
                <div className="image">
                  { activeUser ? <Gravatar email={ activeUser ? activeUser.email : activeShop.contact.email } size={ 40 }/> : null }
                </div>
              </Col>
              <Col span={ 18 }>
                <div className="text-content">
                  <h4 className="mt-0">{ activeShop.name }</h4>
                  { activeUser ? `${activeUser.display_name} (${activeUser.email})` : null }
                </div>
                <Icon type="down" />
              </Col>
            </Row>
          </Dropdown>
        : null }
      </div>
    )
  }
}